import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Center, Loader } from '@mantine/core'
import './styles/main.sass'

// GameContainer stays eager: it's the invite-link hot path
import GameContainer from './components/GameContainer'

const NewGame = lazy(() => import('./components/NewGame'))
const NotFound = lazy(() => import('./components/NotFound'))
const Lobby = lazy(() => import('./components/Lobby'))
const StackResults = lazy(() => import('./components/StackResults'))
const GameResults = lazy(() => import('./components/GameResults'))

function App() {
  return (
    <Router>
      <div className="app">
        <Suspense
          fallback={
            <Center h="100vh">
              <Loader type="bars" size="lg" color="#0da388" />
            </Center>
          }
        >
          <Routes>
            <Route path="/" element={<Lobby />} />
            <Route path="/games/new" element={<NewGame />} />
            <Route path="/games/:gameKey" element={<GameContainer />} />
            <Route path="/games/:gameKey/avatar" element={<GameContainer />} />
            <Route path="/games/:gameKey/avatar/history" element={<GameContainer />} />
            <Route path="/games/:gameKey/results" element={<GameResults />} />
            <Route path="/games/:gameKey/:playerName" element={<StackResults />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  )
}

export default App
